import React from "react";

const HomePage = () => {
  return <div className="main main-home"></div>;
};

export default HomePage;
